export default "__VITE_ASSET__VUtYTyez__"